import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { isAcceleratorCategoryVisible, isPlatformRouteVisible } from './site-config';

// English
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enHome2 from './locales/en/home-2.json';
import enHome3 from './locales/en/home-3.json';
import enHome4 from './locales/en/home-4.json';
import enHome5 from './locales/en/home-5.json';
import enAdmin from './locales/en/admin.json';
import enNavigation from './locales/en/navigation.json';
import enSubscriptionPlans from './locales/en/subscription-plans.json';
import enNewsletter from './locales/en/newsletter.json';
import enPrvProspecting from './locales/en/prv-prospecting.json';
import enPrvProspectingData from './locales/en/prv-prospecting-data.json';
import enUserDashboard from './locales/en/user-dashboard.json';
import enVideoLibrary from './locales/en/video-library.json';
import enOrgDashboard from './locales/en/org-dashboard.json';
import enOrgSubscriptionSuccess from './locales/en/org-subscription-success.json';
import enSubscriptionPlansOrg from './locales/en/subscription-plans-org.json';
import enLegal from './locales/en/legal.json';
import enFaq from './locales/en/faq.json';

// English - Accelerators
import enAcceleratorsCommon from './locales/en/accelerators/common.json';
import enAiAcceleratorsTable from './locales/en/accelerators/ai-accelerators-table.json';
import enAiArtistStudioAccelerators from './locales/en/accelerators/ai-artist-studio-accelerators.json';
import enAiAutomotiveAccelerators from './locales/en/accelerators/ai-automotive-accelerators.json';
import enAiBlackMenAccelerators from './locales/en/accelerators/ai-black-men-accelerators.json';
import enAiBlackWomenAccelerators from './locales/en/accelerators/ai-black-women-accelerators.json';
import enAiChristianAccelerators from './locales/en/accelerators/ai-christian-accelerators.json';
import enAiCulinaryAccelerators from './locales/en/accelerators/ai-culinary-accelerators.json';
import enAiDisabilityAccelerators from './locales/en/accelerators/ai-disability-accelerators.json';
import enAiEngineeringAccelerators from './locales/en/accelerators/ai-engineering-accelerators.json';
import enAiEnvironmentAccelerators from './locales/en/accelerators/ai-environment-accelerators.json';
import enAiFilmStudioAccelerators from './locales/en/accelerators/ai-film-studio-accelerators.json';
import enAiFurnitureMakingAccelerators from './locales/en/accelerators/ai-furniture-making-accelerators.json';
import enAiHotelHospitalityAccelerators from './locales/en/accelerators/ai-hotel-hospitality-accelerators.json';
import enAiIndigenousAccelerators from './locales/en/accelerators/ai-indigenous-accelerators.json';
import enAiJewishAccelerators from './locales/en/accelerators/ai-jewish-accelerators.json';
import enAiLatinoAccelerators from './locales/en/accelerators/ai-latino-accelerators.json';
import enAiLgbtqAccelerators from './locales/en/accelerators/ai-lgbtq-accelerators.json';
import enAiLowIncomeAccelerators from './locales/en/accelerators/ai-low-income-accelerators.json';
import enAiMedicalAccelerators from './locales/en/accelerators/ai-medical-accelerators.json';
import enAiMinorityAccelerators from './locales/en/accelerators/ai-minority-accelerators.json';
import enAiMusicStudioAccelerators from './locales/en/accelerators/ai-music-studio-accelerators.json';
import enAiMuslimAccelerators from './locales/en/accelerators/ai-muslim-accelerators.json';
import enAiNextStepAccelerators from './locales/en/accelerators/ai-next-step-accelerators.json';
import enAiPanamaAccelerators from './locales/en/accelerators/ai-panama-accelerators.json';
import enAiRealEstateAccelerators from './locales/en/accelerators/ai-real-estate-accelerators.json';
import enAiRuralAccelerators from './locales/en/accelerators/ai-rural-accelerators.json';
import enAiSeniorAccelerators from './locales/en/accelerators/ai-senior-accelerators.json';
import enAiSewingFashionAccelerators from './locales/en/accelerators/ai-sewing-fashion-accelerators.json';
import enAiSingleParentAccelerators from './locales/en/accelerators/ai-single-parent-accelerators.json';
import enAiStemAccelerators from './locales/en/accelerators/ai-stem-accelerators.json';
import enAiUniversityStudentAccelerators from './locales/en/accelerators/ai-university-student-accelerators.json';
import enAiVeteransAccelerators from './locales/en/accelerators/ai-veterans-accelerators.json';
import enAiVocationalAccelerators from './locales/en/accelerators/ai-vocational-accelerators.json';
import enAiWellnessBeautyAccelerators from './locales/en/accelerators/ai-wellness-beauty-accelerators.json';
import enAiWomenAccelerators from './locales/en/accelerators/ai-women-accelerators.json';

// English - Accelerator Narrative
import enGoToMarketStrategy from './locales/en/accelerators/go-to-market-strategy.json';
import enLongDescription from './locales/en/accelerators/long-description.json';
import enMarketSize from './locales/en/accelerators/market-size.json';
import enOneLinePitch from './locales/en/accelerators/one-line-pitch.json';
import enProblemStatement from './locales/en/accelerators/problem-statement.json';
import enShortDescription from './locales/en/accelerators/short-description.json';
import enSolutionDescription from './locales/en/accelerators/solution-description.json';
import enTargetMarket from './locales/en/accelerators/target-market.json';
import enTeamDescription from './locales/en/accelerators/team-description.json';
import enThreeYearPlan from './locales/en/accelerators/three-year-plan.json';
import enTractionSummary from './locales/en/accelerators/traction-summary.json';
import enUnitEconomics from './locales/en/accelerators/unit-economics.json';
import enUnitEconomicsDashboard from './locales/en/accelerators/unit-economics-dashboard.json';
import enUseOfFunds from './locales/en/accelerators/use-of-funds.json';
import enVisionStatement from './locales/en/accelerators/vision-statement.json';
import enWhyNow from './locales/en/accelerators/why-now.json';
import enBeachheadMarket from './locales/en/accelerators/beachhead-market.json';
import enBusinessModelCanvas from './locales/en/accelerators/business-model-canvas.json';
import enCompetitivePositioning from './locales/en/accelerators/competitive-positioning.json';
import enFounderIdentity from './locales/en/accelerators/founder-identity.json';
import enFounderPresence from './locales/en/accelerators/founder-presence.json';
import enFundingStrategy from './locales/en/accelerators/funding-strategy.json';
import enMetricsFramework from './locales/en/accelerators/metrics-framework.json';
import enMilestoneRoadmap from './locales/en/accelerators/milestone-roadmap.json';
import enProductShowcase from './locales/en/accelerators/product-showcase.json';
import enTeamStrategy from './locales/en/accelerators/team-strategy.json';

// English - Founders
import enInvestorFounderSearch from './locales/en/accelerators/investor-founder-search.json';
import enMyFounderLexicon from './locales/en/accelerators/my-founder-lexicon.json';
import enMyFounderProfile from './locales/en/accelerators/my-founder-profile.json';

// English - Calendars
import enCommsCalendar from './locales/en/accelerators/comms-calendar.json';

// English - Partnership Tools
import enPartnershipOptimizer from './locales/en/accelerators/partnership-optimizer.json';

// English - Sewing & Fashion
import enMissouriStarProfitCalculator from './locales/en/accelerators/missouri-star-profit-calculator.json';
import enMissouriStarRetreatPlanner from './locales/en/accelerators/missouri-star-retreat-planner.json';
import enMissouriStarTutorialFinder from './locales/en/accelerators/missouri-star-tutorial-finder.json';
import enMulqueenFindYourClass from './locales/en/accelerators/mulqueen-find-your-class.json';
import enMulqueenSewingExplorer from './locales/en/accelerators/mulqueen-sewing-explorer.json';
import enThreadworksSewingExplorer from './locales/en/accelerators/threadworks-sewing-explorer.json';
import enSvpBusinessBuilder from './locales/en/accelerators/svp-business-builder.json';
import enSvpMachineFinder from './locales/en/accelerators/svp-machine-finder.json';

// English - Accelerator Tools
import enAcceleratorComparisonFramework from './locales/en/accelerators/accelerator-comparison-framework.json';
import enAcceptanceRateReality from './locales/en/accelerators/acceptance-rate-reality.json';
import enAlumniNetworkEstimator from './locales/en/accelerators/alumni-network-estimator.json';
import enCohortTimingStrategy from './locales/en/accelerators/cohort-timing-strategy.json';
import enDeadlineCalculator from './locales/en/accelerators/deadline-calculator.json';
import enDemoDayPrepGuide from './locales/en/accelerators/demo-day-prep-guide.json';
import enDueDiligenceChecklist from './locales/en/accelerators/due-diligence-checklist.json';
import enEquityDilutionVisualizer from './locales/en/accelerators/equity-dilution-visualizer.json';
import enSafeInvestmentModel from './locales/en/accelerators/safe-investment-model.json';
import enFilmStudioBudget from './locales/en/accelerators/film-studio-budget.json';
import enSewingFashionBudget from './locales/en/accelerators/sewing-fashion-budget.json';
import enArtistStudioBudget from './locales/en/accelerators/artist-studio-budget.json';
import enAutomotiveBudget from './locales/en/accelerators/automotive-budget.json';
import enBlackMenBudget from './locales/en/accelerators/black-men-budget.json';
import enBlackWomenBudget from './locales/en/accelerators/black-women-budget.json';
import enChristianBudget from './locales/en/accelerators/christian-budget.json';
import enCulinaryBudget from './locales/en/accelerators/culinary-budget.json';
import enDisabilityBudget from './locales/en/accelerators/disability-budget.json';
import enEngineeringBudget from './locales/en/accelerators/engineering-budget.json';
import enEnvironmentBudget from './locales/en/accelerators/environment-budget.json';
import enFurnitureMakingBudget from './locales/en/accelerators/furniture-making-budget.json';
import enHotelHospitalityBudget from './locales/en/accelerators/hotel-hospitality-budget.json';
import enIndigenousBudget from './locales/en/accelerators/indigenous-budget.json';
import enJewishBudget from './locales/en/accelerators/jewish-budget.json';
import enLGBTQBudget from './locales/en/accelerators/lgbtq-budget.json';
import enLatinoBudget from './locales/en/accelerators/latino-budget.json';
import enLowIncomeBudget from './locales/en/accelerators/low-income-budget.json';
import enMedicalBudget from './locales/en/accelerators/medical-budget.json';
import enMinorityBudget from './locales/en/accelerators/minority-budget.json';
import enMusicStudioBudget from './locales/en/accelerators/music-studio-budget.json';
import enMuslimBudget from './locales/en/accelerators/muslim-budget.json';
import enNextStepBudget from './locales/en/accelerators/next-step-budget.json';
import enPanamaBudget from './locales/en/accelerators/panama-budget.json';
import enRealEstateBudget from './locales/en/accelerators/real-estate-budget.json';
import enRuralBudget from './locales/en/accelerators/rural-budget.json';
import enSTEMBudget from './locales/en/accelerators/stem-budget.json';
import enSeniorBudget from './locales/en/accelerators/senior-budget.json';
import enSingleParentBudget from './locales/en/accelerators/single-parent-budget.json';
import enUniversityStudentBudget from './locales/en/accelerators/university-student-budget.json';
import enVeteransBudget from './locales/en/accelerators/veterans-budget.json';
import enVocationalBudget from './locales/en/accelerators/vocational-budget.json';
import enWellnessBeautyBudget from './locales/en/accelerators/wellness-beauty-budget.json';
import enWomenBudget from './locales/en/accelerators/women-budget.json';
import enFounderMarketFitAssessment from './locales/en/accelerators/founder-market-fit-assessment.json';
import enFounderStoryFramework from './locales/en/accelerators/founder-story-framework.json';
import enFundingLandscapeInfographics from './locales/en/accelerators/funding-landscape-infographics.json';
import enFundingMultiplierCalculator from './locales/en/accelerators/funding-multiplier-calculator.json';
import enFundingReadinessAssessment from './locales/en/accelerators/funding-readiness-assessment.json';
import enHiddenGemsReport from './locales/en/accelerators/hidden-gems-report.json';
import enInterviewPrepGuide from './locales/en/accelerators/interview-prep-guide.json';
import enMonthlyAmaTemplate from './locales/en/accelerators/monthly-ama-template.json';
import enNetworkingRoiCalculator from './locales/en/accelerators/networking-roi-calculator.json';
import enPitchDeckFramework from './locales/en/accelerators/pitch-deck-framework.json';
import enPortfolioStrategyCalculator from './locales/en/accelerators/portfolio-strategy-calculator.json';
import enPostAcceptanceNegotiation from './locales/en/accelerators/post-acceptance-negotiation.json';
import enProgramFitScorecard from './locales/en/accelerators/program-fit-scorecard.json';
import enProgramResearchMethodology from './locales/en/accelerators/program-research-methodology.json';
import enReapplicationStrategyGuide from './locales/en/accelerators/reapplication-strategy-guide.json';
import enRedFlagsChecklist from './locales/en/accelerators/red-flags-checklist.json';
import enReferenceCheckGuide from './locales/en/accelerators/reference-check-guide.json';
import enRejectionRecoveryFramework from './locales/en/accelerators/rejection-recovery-framework.json';
import enSalesStrategyOptimizer from './locales/en/accelerators/sales-strategy-optimizer.json';
import enStageAppropriateFinder from './locales/en/accelerators/stage-appropriate-finder.json';
import enThe100HourProblem from './locales/en/accelerators/the-100-hour-problem.json';
import enWeeklyDeadlineDigest from './locales/en/accelerators/weekly-deadline-digest.json';
import enWhatAcceleratorsLookFor from './locales/en/accelerators/what-accelerators-look-for.json';
import enPartnershipOptimizerLegacy from './locales/en/accelerators/partnership-optimizer-legacy.json';

// English - Accelerator Tools (Value-Add Modules)
import enRunwayScenarioModel from './locales/en/accelerators/runway-scenario-model.json';
import enCustomerDiscoveryTracker from './locales/en/accelerators/customer-discovery-tracker.json';
import enInvestorPipelineTracker from './locales/en/accelerators/investor-pipeline-tracker.json';
import enInvestorUpdateGenerator from './locales/en/accelerators/investor-update-generator.json';
import enMentorOfficeHours from './locales/en/accelerators/mentor-office-hours.json';
import enEsopOptionPoolPlanner from './locales/en/accelerators/esop-option-pool-planner.json';
import enCohortBenchmarking from './locales/en/accelerators/cohort-benchmarking.json';
import enDataRoomBuilder from './locales/en/accelerators/data-room-builder.json';
import enMyAcceleratorTracker from './locales/en/accelerators/my-accelerator-tracker.json';

// English - Video Animations (per-vertical)
import enVideoAnimArtistStudio from './locales/en/video-animations/artist-studio.json';
import enVideoAnimAutomotive from './locales/en/video-animations/automotive.json';
import enVideoAnimBlackMen from './locales/en/video-animations/black-men.json';
import enVideoAnimBlackWomen from './locales/en/video-animations/black-women.json';
import enVideoAnimChristian from './locales/en/video-animations/christian.json';
import enVideoAnimCulinary from './locales/en/video-animations/culinary.json';
import enVideoAnimDisability from './locales/en/video-animations/disability.json';
import enVideoAnimEngineering from './locales/en/video-animations/engineering.json';
import enVideoAnimEnvironment from './locales/en/video-animations/environment.json';
import enVideoAnimFilmStudio from './locales/en/video-animations/film-studio.json';
import enVideoAnimFurnitureMaking from './locales/en/video-animations/furniture-making.json';
import enVideoAnimHotelHospitality from './locales/en/video-animations/hotel-hospitality.json';
import enVideoAnimIndigenous from './locales/en/video-animations/indigenous.json';
import enVideoAnimJewish from './locales/en/video-animations/jewish.json';
import enVideoAnimLGBTQ from './locales/en/video-animations/lgbtq.json';
import enVideoAnimLatino from './locales/en/video-animations/latino.json';
import enVideoAnimLowIncome from './locales/en/video-animations/low-income.json';
import enVideoAnimMedical from './locales/en/video-animations/medical.json';
import enVideoAnimMinority from './locales/en/video-animations/minority.json';
import enVideoAnimMusicStudio from './locales/en/video-animations/music-studio.json';
import enVideoAnimMuslim from './locales/en/video-animations/muslim.json';
import enVideoAnimNextStep from './locales/en/video-animations/next-step.json';
import enVideoAnimRealEstate from './locales/en/video-animations/real-estate.json';
import enVideoAnimRural from './locales/en/video-animations/rural.json';
import enVideoAnimSTEM from './locales/en/video-animations/stem.json';
import enVideoAnimSenior from './locales/en/video-animations/senior.json';
import enVideoAnimSewingFashion from './locales/en/video-animations/sewing-fashion.json';
import enVideoAnimSingleParent from './locales/en/video-animations/single-parent.json';
import enVideoAnimUniversityStudent from './locales/en/video-animations/university-student.json';
import enVideoAnimVeterans from './locales/en/video-animations/veterans.json';
import enVideoAnimVocational from './locales/en/video-animations/vocational.json';
import enVideoAnimWellnessBeauty from './locales/en/video-animations/wellness-beauty.json';
import enVideoAnimWomen from './locales/en/video-animations/women.json';
import enVideoAnimHifiArtistStudio from './locales/en/video-animations-hifi/artist-studio.json';
import enVideoAnimHifiAutomotive from './locales/en/video-animations-hifi/automotive.json';
import enVideoAnimHifiBlackMen from './locales/en/video-animations-hifi/black-men.json';
import enVideoAnimHifiBlackWomen from './locales/en/video-animations-hifi/black-women.json';
import enVideoAnimHifiChristian from './locales/en/video-animations-hifi/christian.json';
import enVideoAnimHifiCulinary from './locales/en/video-animations-hifi/culinary.json';
import enVideoAnimHifiDisability from './locales/en/video-animations-hifi/disability.json';
import enVideoAnimHifiEngineering from './locales/en/video-animations-hifi/engineering.json';
import enVideoAnimHifiEnvironment from './locales/en/video-animations-hifi/environment.json';
import enVideoAnimHifiFilmStudio from './locales/en/video-animations-hifi/film-studio.json';
import enVideoAnimHifiFurnitureMaking from './locales/en/video-animations-hifi/furniture-making.json';
import enVideoAnimHifiHotelHospitality from './locales/en/video-animations-hifi/hotel-hospitality.json';
import enVideoAnimHifiIndigenous from './locales/en/video-animations-hifi/indigenous.json';
import enVideoAnimHifiJewish from './locales/en/video-animations-hifi/jewish.json';
import enVideoAnimHifiLGBTQ from './locales/en/video-animations-hifi/lgbtq.json';
import enVideoAnimHifiLatino from './locales/en/video-animations-hifi/latino.json';
import enVideoAnimHifiLowIncome from './locales/en/video-animations-hifi/low-income.json';
import enVideoAnimHifiMedical from './locales/en/video-animations-hifi/medical.json';
import enVideoAnimHifiMinority from './locales/en/video-animations-hifi/minority.json';
import enVideoAnimHifiMusicStudio from './locales/en/video-animations-hifi/music-studio.json';
import enVideoAnimHifiMuslim from './locales/en/video-animations-hifi/muslim.json';
import enVideoAnimHifiNextStep from './locales/en/video-animations-hifi/next-step.json';
import enVideoAnimHifiPanama from './locales/en/video-animations-hifi/panama.json';
import enVideoAnimHifiRealEstate from './locales/en/video-animations-hifi/real-estate.json';
import enVideoAnimHifiRural from './locales/en/video-animations-hifi/rural.json';
import enVideoAnimHifiSTEM from './locales/en/video-animations-hifi/stem.json';
import enVideoAnimHifiSenior from './locales/en/video-animations-hifi/senior.json';
import enVideoAnimHifiSewingFashion from './locales/en/video-animations-hifi/sewing-fashion.json';
import enVideoAnimHifiSingleParent from './locales/en/video-animations-hifi/single-parent.json';
import enVideoAnimHifiUniversityStudent from './locales/en/video-animations-hifi/university-student.json';
import enVideoAnimHifiVeterans from './locales/en/video-animations-hifi/veterans.json';
import enVideoAnimHifiVocational from './locales/en/video-animations-hifi/vocational.json';
import enVideoAnimHifiWellnessBeauty from './locales/en/video-animations-hifi/wellness-beauty.json';
import enVideoAnimHifiWomen from './locales/en/video-animations-hifi/women.json';

// Spanish
import esCommon from './locales/es/common.json';
import esLegal from './locales/es/legal.json';
import esFaq from './locales/es/faq.json';
import esHome from './locales/es/home.json';
import esHome2 from './locales/es/home-2.json';
import esHome3 from './locales/es/home-3.json';
import esHome4 from './locales/es/home-4.json';
import esHome5 from './locales/es/home-5.json';
import esAdmin from './locales/es/admin.json';
import esNavigation from './locales/es/navigation.json';
import esSubscriptionPlans from './locales/es/subscription-plans.json';
import esNewsletter from './locales/es/newsletter.json';
import esPrvProspecting from './locales/es/prv-prospecting.json';
import esPrvProspectingData from './locales/es/prv-prospecting-data.json';
import esUserDashboard from './locales/es/user-dashboard.json';
import esVideoLibrary from './locales/es/video-library.json';

// Spanish - Accelerators
import esAcceleratorsCommon from './locales/es/accelerators/common.json';
import esAiAcceleratorsTable from './locales/es/accelerators/ai-accelerators-table.json';
import esAiArtistStudioAccelerators from './locales/es/accelerators/ai-artist-studio-accelerators.json';
import esAiAutomotiveAccelerators from './locales/es/accelerators/ai-automotive-accelerators.json';
import esAiBlackMenAccelerators from './locales/es/accelerators/ai-black-men-accelerators.json';
import esAiBlackWomenAccelerators from './locales/es/accelerators/ai-black-women-accelerators.json';
import esAiChristianAccelerators from './locales/es/accelerators/ai-christian-accelerators.json';
import esAiCulinaryAccelerators from './locales/es/accelerators/ai-culinary-accelerators.json';
import esAiDisabilityAccelerators from './locales/es/accelerators/ai-disability-accelerators.json';
import esAiEngineeringAccelerators from './locales/es/accelerators/ai-engineering-accelerators.json';
import esAiEnvironmentAccelerators from './locales/es/accelerators/ai-environment-accelerators.json';
import esAiFilmStudioAccelerators from './locales/es/accelerators/ai-film-studio-accelerators.json';
import esAiFurnitureMakingAccelerators from './locales/es/accelerators/ai-furniture-making-accelerators.json';
import esAiHotelHospitalityAccelerators from './locales/es/accelerators/ai-hotel-hospitality-accelerators.json';
import esAiIndigenousAccelerators from './locales/es/accelerators/ai-indigenous-accelerators.json';
import esAiJewishAccelerators from './locales/es/accelerators/ai-jewish-accelerators.json';
import esAiLatinoAccelerators from './locales/es/accelerators/ai-latino-accelerators.json';
import esAiLgbtqAccelerators from './locales/es/accelerators/ai-lgbtq-accelerators.json';
import esAiLowIncomeAccelerators from './locales/es/accelerators/ai-low-income-accelerators.json';
import esAiMedicalAccelerators from './locales/es/accelerators/ai-medical-accelerators.json';
import esAiMinorityAccelerators from './locales/es/accelerators/ai-minority-accelerators.json';
import esAiMusicStudioAccelerators from './locales/es/accelerators/ai-music-studio-accelerators.json';
import esAiMuslimAccelerators from './locales/es/accelerators/ai-muslim-accelerators.json';
import esAiNextStepAccelerators from './locales/es/accelerators/ai-next-step-accelerators.json';
import esAiPanamaAccelerators from './locales/es/accelerators/ai-panama-accelerators.json';
import esAiRealEstateAccelerators from './locales/es/accelerators/ai-real-estate-accelerators.json';
import esAiRuralAccelerators from './locales/es/accelerators/ai-rural-accelerators.json';
import esAiSeniorAccelerators from './locales/es/accelerators/ai-senior-accelerators.json';
import esAiSewingFashionAccelerators from './locales/es/accelerators/ai-sewing-fashion-accelerators.json';
import esAiSingleParentAccelerators from './locales/es/accelerators/ai-single-parent-accelerators.json';
import esAiStemAccelerators from './locales/es/accelerators/ai-stem-accelerators.json';
import esAiUniversityStudentAccelerators from './locales/es/accelerators/ai-university-student-accelerators.json';
import esAiVeteransAccelerators from './locales/es/accelerators/ai-veterans-accelerators.json';
import esAiVocationalAccelerators from './locales/es/accelerators/ai-vocational-accelerators.json';
import esAiWellnessBeautyAccelerators from './locales/es/accelerators/ai-wellness-beauty-accelerators.json';
import esAiWomenAccelerators from './locales/es/accelerators/ai-women-accelerators.json';

// Spanish - Accelerator Narrative
import esGoToMarketStrategy from './locales/es/accelerators/go-to-market-strategy.json';
import esLongDescription from './locales/es/accelerators/long-description.json';
import esMarketSize from './locales/es/accelerators/market-size.json';
import esOneLinePitch from './locales/es/accelerators/one-line-pitch.json';
import esProblemStatement from './locales/es/accelerators/problem-statement.json';
import esShortDescription from './locales/es/accelerators/short-description.json';
import esSolutionDescription from './locales/es/accelerators/solution-description.json';
import esTargetMarket from './locales/es/accelerators/target-market.json';
import esTeamDescription from './locales/es/accelerators/team-description.json';
import esThreeYearPlan from './locales/es/accelerators/three-year-plan.json';
import esTractionSummary from './locales/es/accelerators/traction-summary.json';
import esUnitEconomics from './locales/es/accelerators/unit-economics.json';
import esUnitEconomicsDashboard from './locales/es/accelerators/unit-economics-dashboard.json';
import esUseOfFunds from './locales/es/accelerators/use-of-funds.json';
import esVisionStatement from './locales/es/accelerators/vision-statement.json';
import esWhyNow from './locales/es/accelerators/why-now.json';
import esBeachheadMarket from './locales/es/accelerators/beachhead-market.json';
import esBusinessModelCanvas from './locales/es/accelerators/business-model-canvas.json';
import esCompetitivePositioning from './locales/es/accelerators/competitive-positioning.json';
import esFounderIdentity from './locales/es/accelerators/founder-identity.json';
import esFounderPresence from './locales/es/accelerators/founder-presence.json';
import esFundingStrategy from './locales/es/accelerators/funding-strategy.json';
import esMetricsFramework from './locales/es/accelerators/metrics-framework.json';
import esMilestoneRoadmap from './locales/es/accelerators/milestone-roadmap.json';
import esProductShowcase from './locales/es/accelerators/product-showcase.json';
import esTeamStrategy from './locales/es/accelerators/team-strategy.json';

// Spanish - Founders
import esInvestorFounderSearch from './locales/es/accelerators/investor-founder-search.json';
import esMyFounderLexicon from './locales/es/accelerators/my-founder-lexicon.json';
import esMyFounderProfile from './locales/es/accelerators/my-founder-profile.json';

// Spanish - Calendars
import esCommsCalendar from './locales/es/accelerators/comms-calendar.json';

// Spanish - Partnership Tools
import esPartnershipOptimizer from './locales/es/accelerators/partnership-optimizer.json';

// Spanish - Sewing & Fashion
import esMissouriStarProfitCalculator from './locales/es/accelerators/missouri-star-profit-calculator.json';
import esMissouriStarRetreatPlanner from './locales/es/accelerators/missouri-star-retreat-planner.json';
import esMissouriStarTutorialFinder from './locales/es/accelerators/missouri-star-tutorial-finder.json';
import esMulqueenFindYourClass from './locales/es/accelerators/mulqueen-find-your-class.json';
import esMulqueenSewingExplorer from './locales/es/accelerators/mulqueen-sewing-explorer.json';
import esThreadworksSewingExplorer from './locales/es/accelerators/threadworks-sewing-explorer.json';
import esSvpBusinessBuilder from './locales/es/accelerators/svp-business-builder.json';
import esSvpMachineFinder from './locales/es/accelerators/svp-machine-finder.json';

// Spanish - Accelerator Tools
import esAcceleratorComparisonFramework from './locales/es/accelerators/accelerator-comparison-framework.json';
import esAcceptanceRateReality from './locales/es/accelerators/acceptance-rate-reality.json';
import esAlumniNetworkEstimator from './locales/es/accelerators/alumni-network-estimator.json';
import esCohortTimingStrategy from './locales/es/accelerators/cohort-timing-strategy.json';
import esDeadlineCalculator from './locales/es/accelerators/deadline-calculator.json';
import esDemoDayPrepGuide from './locales/es/accelerators/demo-day-prep-guide.json';
import esDueDiligenceChecklist from './locales/es/accelerators/due-diligence-checklist.json';
import esEquityDilutionVisualizer from './locales/es/accelerators/equity-dilution-visualizer.json';
import esSafeInvestmentModel from './locales/es/accelerators/safe-investment-model.json';
import esFilmStudioBudget from './locales/es/accelerators/film-studio-budget.json';
import esSewingFashionBudget from './locales/es/accelerators/sewing-fashion-budget.json';
import esArtistStudioBudget from './locales/es/accelerators/artist-studio-budget.json';
import esAutomotiveBudget from './locales/es/accelerators/automotive-budget.json';
import esBlackMenBudget from './locales/es/accelerators/black-men-budget.json';
import esBlackWomenBudget from './locales/es/accelerators/black-women-budget.json';
import esChristianBudget from './locales/es/accelerators/christian-budget.json';
import esCulinaryBudget from './locales/es/accelerators/culinary-budget.json';
import esDisabilityBudget from './locales/es/accelerators/disability-budget.json';
import esEngineeringBudget from './locales/es/accelerators/engineering-budget.json';
import esEnvironmentBudget from './locales/es/accelerators/environment-budget.json';
import esFurnitureMakingBudget from './locales/es/accelerators/furniture-making-budget.json';
import esHotelHospitalityBudget from './locales/es/accelerators/hotel-hospitality-budget.json';
import esIndigenousBudget from './locales/es/accelerators/indigenous-budget.json';
import esJewishBudget from './locales/es/accelerators/jewish-budget.json';
import esLGBTQBudget from './locales/es/accelerators/lgbtq-budget.json';
import esLatinoBudget from './locales/es/accelerators/latino-budget.json';
import esLowIncomeBudget from './locales/es/accelerators/low-income-budget.json';
import esMedicalBudget from './locales/es/accelerators/medical-budget.json';
import esMinorityBudget from './locales/es/accelerators/minority-budget.json';
import esMusicStudioBudget from './locales/es/accelerators/music-studio-budget.json';
import esMuslimBudget from './locales/es/accelerators/muslim-budget.json';
import esNextStepBudget from './locales/es/accelerators/next-step-budget.json';
import esPanamaBudget from './locales/es/accelerators/panama-budget.json';
import esRealEstateBudget from './locales/es/accelerators/real-estate-budget.json';
import esRuralBudget from './locales/es/accelerators/rural-budget.json';
import esSTEMBudget from './locales/es/accelerators/stem-budget.json';
import esSeniorBudget from './locales/es/accelerators/senior-budget.json';
import esSingleParentBudget from './locales/es/accelerators/single-parent-budget.json';
import esUniversityStudentBudget from './locales/es/accelerators/university-student-budget.json';
import esVeteransBudget from './locales/es/accelerators/veterans-budget.json';
import esVocationalBudget from './locales/es/accelerators/vocational-budget.json';
import esWellnessBeautyBudget from './locales/es/accelerators/wellness-beauty-budget.json';
import esWomenBudget from './locales/es/accelerators/women-budget.json';
import esFounderMarketFitAssessment from './locales/es/accelerators/founder-market-fit-assessment.json';
import esFounderStoryFramework from './locales/es/accelerators/founder-story-framework.json';
import esFundingLandscapeInfographics from './locales/es/accelerators/funding-landscape-infographics.json';
import esFundingMultiplierCalculator from './locales/es/accelerators/funding-multiplier-calculator.json';
import esFundingReadinessAssessment from './locales/es/accelerators/funding-readiness-assessment.json';
import esHiddenGemsReport from './locales/es/accelerators/hidden-gems-report.json';
import esInterviewPrepGuide from './locales/es/accelerators/interview-prep-guide.json';
import esMonthlyAmaTemplate from './locales/es/accelerators/monthly-ama-template.json';
import esNetworkingRoiCalculator from './locales/es/accelerators/networking-roi-calculator.json';
import esPitchDeckFramework from './locales/es/accelerators/pitch-deck-framework.json';
import esPortfolioStrategyCalculator from './locales/es/accelerators/portfolio-strategy-calculator.json';
import esPostAcceptanceNegotiation from './locales/es/accelerators/post-acceptance-negotiation.json';
import esProgramFitScorecard from './locales/es/accelerators/program-fit-scorecard.json';
import esProgramResearchMethodology from './locales/es/accelerators/program-research-methodology.json';
import esReapplicationStrategyGuide from './locales/es/accelerators/reapplication-strategy-guide.json';
import esRedFlagsChecklist from './locales/es/accelerators/red-flags-checklist.json';
import esReferenceCheckGuide from './locales/es/accelerators/reference-check-guide.json';
import esRejectionRecoveryFramework from './locales/es/accelerators/rejection-recovery-framework.json';
import esSalesStrategyOptimizer from './locales/es/accelerators/sales-strategy-optimizer.json';
import esStageAppropriateFinder from './locales/es/accelerators/stage-appropriate-finder.json';
import esThe100HourProblem from './locales/es/accelerators/the-100-hour-problem.json';
import esWeeklyDeadlineDigest from './locales/es/accelerators/weekly-deadline-digest.json';
import esWhatAcceleratorsLookFor from './locales/es/accelerators/what-accelerators-look-for.json';
import esPartnershipOptimizerLegacy from './locales/es/accelerators/partnership-optimizer-legacy.json';

// Spanish - Accelerator Tools (Value-Add Modules)
import esRunwayScenarioModel from './locales/es/accelerators/runway-scenario-model.json';
import esCustomerDiscoveryTracker from './locales/es/accelerators/customer-discovery-tracker.json';
import esInvestorPipelineTracker from './locales/es/accelerators/investor-pipeline-tracker.json';
import esInvestorUpdateGenerator from './locales/es/accelerators/investor-update-generator.json';
import esMentorOfficeHours from './locales/es/accelerators/mentor-office-hours.json';
import esEsopOptionPoolPlanner from './locales/es/accelerators/esop-option-pool-planner.json';
import esCohortBenchmarking from './locales/es/accelerators/cohort-benchmarking.json';
import esDataRoomBuilder from './locales/es/accelerators/data-room-builder.json';
import esMyAcceleratorTracker from './locales/es/accelerators/my-accelerator-tracker.json';

// Spanish - Video Animations (per-vertical)
import esVideoAnimArtistStudio from './locales/es/video-animations/artist-studio.json';
import esVideoAnimAutomotive from './locales/es/video-animations/automotive.json';
import esVideoAnimBlackMen from './locales/es/video-animations/black-men.json';
import esVideoAnimBlackWomen from './locales/es/video-animations/black-women.json';
import esVideoAnimChristian from './locales/es/video-animations/christian.json';
import esVideoAnimCulinary from './locales/es/video-animations/culinary.json';
import esVideoAnimDisability from './locales/es/video-animations/disability.json';
import esVideoAnimEngineering from './locales/es/video-animations/engineering.json';
import esVideoAnimEnvironment from './locales/es/video-animations/environment.json';
import esVideoAnimFilmStudio from './locales/es/video-animations/film-studio.json';
import esVideoAnimFurnitureMaking from './locales/es/video-animations/furniture-making.json';
import esVideoAnimHotelHospitality from './locales/es/video-animations/hotel-hospitality.json';
import esVideoAnimIndigenous from './locales/es/video-animations/indigenous.json';
import esVideoAnimJewish from './locales/es/video-animations/jewish.json';
import esVideoAnimLGBTQ from './locales/es/video-animations/lgbtq.json';
import esVideoAnimLatino from './locales/es/video-animations/latino.json';
import esVideoAnimLowIncome from './locales/es/video-animations/low-income.json';
import esVideoAnimMedical from './locales/es/video-animations/medical.json';
import esVideoAnimMinority from './locales/es/video-animations/minority.json';
import esVideoAnimMusicStudio from './locales/es/video-animations/music-studio.json';
import esVideoAnimMuslim from './locales/es/video-animations/muslim.json';
import esVideoAnimNextStep from './locales/es/video-animations/next-step.json';
import esVideoAnimRealEstate from './locales/es/video-animations/real-estate.json';
import esVideoAnimRural from './locales/es/video-animations/rural.json';
import esVideoAnimSTEM from './locales/es/video-animations/stem.json';
import esVideoAnimSenior from './locales/es/video-animations/senior.json';
import esVideoAnimSewingFashion from './locales/es/video-animations/sewing-fashion.json';
import esVideoAnimSingleParent from './locales/es/video-animations/single-parent.json';
import esVideoAnimUniversityStudent from './locales/es/video-animations/university-student.json';
import esVideoAnimVeterans from './locales/es/video-animations/veterans.json';
import esVideoAnimVocational from './locales/es/video-animations/vocational.json';
import esVideoAnimWellnessBeauty from './locales/es/video-animations/wellness-beauty.json';
import esVideoAnimWomen from './locales/es/video-animations/women.json';
import esVideoAnimHifiArtistStudio from './locales/es/video-animations-hifi/artist-studio.json';
import esVideoAnimHifiAutomotive from './locales/es/video-animations-hifi/automotive.json';
import esVideoAnimHifiBlackMen from './locales/es/video-animations-hifi/black-men.json';
import esVideoAnimHifiBlackWomen from './locales/es/video-animations-hifi/black-women.json';
import esVideoAnimHifiChristian from './locales/es/video-animations-hifi/christian.json';
import esVideoAnimHifiCulinary from './locales/es/video-animations-hifi/culinary.json';
import esVideoAnimHifiDisability from './locales/es/video-animations-hifi/disability.json';
import esVideoAnimHifiEngineering from './locales/es/video-animations-hifi/engineering.json';
import esVideoAnimHifiEnvironment from './locales/es/video-animations-hifi/environment.json';
import esVideoAnimHifiFilmStudio from './locales/es/video-animations-hifi/film-studio.json';
import esVideoAnimHifiFurnitureMaking from './locales/es/video-animations-hifi/furniture-making.json';
import esVideoAnimHifiHotelHospitality from './locales/es/video-animations-hifi/hotel-hospitality.json';
import esVideoAnimHifiIndigenous from './locales/es/video-animations-hifi/indigenous.json';
import esVideoAnimHifiJewish from './locales/es/video-animations-hifi/jewish.json';
import esVideoAnimHifiLGBTQ from './locales/es/video-animations-hifi/lgbtq.json';
import esVideoAnimHifiLatino from './locales/es/video-animations-hifi/latino.json';
import esVideoAnimHifiLowIncome from './locales/es/video-animations-hifi/low-income.json';
import esVideoAnimHifiMedical from './locales/es/video-animations-hifi/medical.json';
import esVideoAnimHifiMinority from './locales/es/video-animations-hifi/minority.json';
import esVideoAnimHifiMusicStudio from './locales/es/video-animations-hifi/music-studio.json';
import esVideoAnimHifiMuslim from './locales/es/video-animations-hifi/muslim.json';
import esVideoAnimHifiNextStep from './locales/es/video-animations-hifi/next-step.json';
import esVideoAnimHifiPanama from './locales/es/video-animations-hifi/panama.json';
import esVideoAnimHifiRealEstate from './locales/es/video-animations-hifi/real-estate.json';
import esVideoAnimHifiRural from './locales/es/video-animations-hifi/rural.json';
import esVideoAnimHifiSTEM from './locales/es/video-animations-hifi/stem.json';
import esVideoAnimHifiSenior from './locales/es/video-animations-hifi/senior.json';
import esVideoAnimHifiSewingFashion from './locales/es/video-animations-hifi/sewing-fashion.json';
import esVideoAnimHifiSingleParent from './locales/es/video-animations-hifi/single-parent.json';
import esVideoAnimHifiUniversityStudent from './locales/es/video-animations-hifi/university-student.json';
import esVideoAnimHifiVeterans from './locales/es/video-animations-hifi/veterans.json';
import esVideoAnimHifiVocational from './locales/es/video-animations-hifi/vocational.json';
import esVideoAnimHifiWellnessBeauty from './locales/es/video-animations-hifi/wellness-beauty.json';
import esVideoAnimHifiWomen from './locales/es/video-animations-hifi/women.json';

// ─── Category slug → translation namespace(s) mapping ───
// These are only loaded if the category is visible for the current site.
const CATEGORY_TRANSLATIONS: Record<string, Record<string, object>> = {
  'ai-artist-studio': { 'ai-artist-studio-accelerators': enAiArtistStudioAccelerators },
  'ai-automotive': { 'ai-automotive-accelerators': enAiAutomotiveAccelerators },
  'ai-black-men': { 'ai-black-men-accelerators': enAiBlackMenAccelerators },
  'ai-black-women': { 'ai-black-women-accelerators': enAiBlackWomenAccelerators },
  'ai-christian': { 'ai-christian-accelerators': enAiChristianAccelerators },
  'ai-culinary': { 'ai-culinary-accelerators': enAiCulinaryAccelerators },
  'ai-disability': { 'ai-disability-accelerators': enAiDisabilityAccelerators },
  'ai-engineering': { 'ai-engineering-accelerators': enAiEngineeringAccelerators },
  'ai-environment': { 'ai-environment-accelerators': enAiEnvironmentAccelerators },
  'ai-film-studio': { 'ai-film-studio-accelerators': enAiFilmStudioAccelerators },
  'ai-furniture-making': { 'ai-furniture-making-accelerators': enAiFurnitureMakingAccelerators },
  'ai-hotel-hospitality': { 'ai-hotel-hospitality-accelerators': enAiHotelHospitalityAccelerators },
  'ai-indigenous': { 'ai-indigenous-accelerators': enAiIndigenousAccelerators },
  'ai-jewish': { 'ai-jewish-accelerators': enAiJewishAccelerators },
  'ai-latino': { 'ai-latino-accelerators': enAiLatinoAccelerators },
  'ai-lgbtq': { 'ai-lgbtq-accelerators': enAiLgbtqAccelerators },
  'ai-low-income': { 'ai-low-income-accelerators': enAiLowIncomeAccelerators },
  'ai-medical': { 'ai-medical-accelerators': enAiMedicalAccelerators },
  'ai-minority': { 'ai-minority-accelerators': enAiMinorityAccelerators },
  'ai-music-studio': { 'ai-music-studio-accelerators': enAiMusicStudioAccelerators },
  'ai-muslim': { 'ai-muslim-accelerators': enAiMuslimAccelerators },
  'ai-next-step': { 'ai-next-step-accelerators': enAiNextStepAccelerators },
  'ai-panama': { 'ai-panama-accelerators': enAiPanamaAccelerators },
  'ai-real-estate': { 'ai-real-estate-accelerators': enAiRealEstateAccelerators },
  'ai-rural': { 'ai-rural-accelerators': enAiRuralAccelerators },
  'ai-senior': { 'ai-senior-accelerators': enAiSeniorAccelerators },
  'ai-sewing-fashion': {
    'ai-sewing-fashion-accelerators': enAiSewingFashionAccelerators,
    'missouri-star-profit-calculator': enMissouriStarProfitCalculator,
    'missouri-star-retreat-planner': enMissouriStarRetreatPlanner,
    'missouri-star-tutorial-finder': enMissouriStarTutorialFinder,
    'mulqueen-find-your-class': enMulqueenFindYourClass,
    'mulqueen-sewing-explorer': enMulqueenSewingExplorer,
    'threadworks-sewing-explorer': enThreadworksSewingExplorer,
    'svp-business-builder': enSvpBusinessBuilder,
    'svp-machine-finder': enSvpMachineFinder,
  },
  'ai-single-parent': { 'ai-single-parent-accelerators': enAiSingleParentAccelerators },
  'ai-stem': { 'ai-stem-accelerators': enAiStemAccelerators },
  'ai-university-student': { 'ai-university-student-accelerators': enAiUniversityStudentAccelerators },
  'ai-veterans': { 'ai-veterans-accelerators': enAiVeteransAccelerators },
  'ai-vocational': { 'ai-vocational-accelerators': enAiVocationalAccelerators },
  'ai-wellness-beauty': { 'ai-wellness-beauty-accelerators': enAiWellnessBeautyAccelerators },
  'ai-women': { 'ai-women-accelerators': enAiWomenAccelerators },
};

// Spanish - Category slug → translation namespace(s) mapping
const ES_CATEGORY_TRANSLATIONS: Record<string, Record<string, object>> = {
  'ai-artist-studio': { 'ai-artist-studio-accelerators': esAiArtistStudioAccelerators },
  'ai-automotive': { 'ai-automotive-accelerators': esAiAutomotiveAccelerators },
  'ai-black-men': { 'ai-black-men-accelerators': esAiBlackMenAccelerators },
  'ai-black-women': { 'ai-black-women-accelerators': esAiBlackWomenAccelerators },
  'ai-christian': { 'ai-christian-accelerators': esAiChristianAccelerators },
  'ai-culinary': { 'ai-culinary-accelerators': esAiCulinaryAccelerators },
  'ai-disability': { 'ai-disability-accelerators': esAiDisabilityAccelerators },
  'ai-engineering': { 'ai-engineering-accelerators': esAiEngineeringAccelerators },
  'ai-environment': { 'ai-environment-accelerators': esAiEnvironmentAccelerators },
  'ai-film-studio': { 'ai-film-studio-accelerators': esAiFilmStudioAccelerators },
  'ai-furniture-making': { 'ai-furniture-making-accelerators': esAiFurnitureMakingAccelerators },
  'ai-hotel-hospitality': { 'ai-hotel-hospitality-accelerators': esAiHotelHospitalityAccelerators },
  'ai-indigenous': { 'ai-indigenous-accelerators': esAiIndigenousAccelerators },
  'ai-jewish': { 'ai-jewish-accelerators': esAiJewishAccelerators },
  'ai-latino': { 'ai-latino-accelerators': esAiLatinoAccelerators },
  'ai-lgbtq': { 'ai-lgbtq-accelerators': esAiLgbtqAccelerators },
  'ai-low-income': { 'ai-low-income-accelerators': esAiLowIncomeAccelerators },
  'ai-medical': { 'ai-medical-accelerators': esAiMedicalAccelerators },
  'ai-minority': { 'ai-minority-accelerators': esAiMinorityAccelerators },
  'ai-music-studio': { 'ai-music-studio-accelerators': esAiMusicStudioAccelerators },
  'ai-muslim': { 'ai-muslim-accelerators': esAiMuslimAccelerators },
  'ai-next-step': { 'ai-next-step-accelerators': esAiNextStepAccelerators },
  'ai-panama': { 'ai-panama-accelerators': esAiPanamaAccelerators },
  'ai-real-estate': { 'ai-real-estate-accelerators': esAiRealEstateAccelerators },
  'ai-rural': { 'ai-rural-accelerators': esAiRuralAccelerators },
  'ai-senior': { 'ai-senior-accelerators': esAiSeniorAccelerators },
  'ai-sewing-fashion': {
    'ai-sewing-fashion-accelerators': esAiSewingFashionAccelerators,
    'missouri-star-profit-calculator': esMissouriStarProfitCalculator,
    'missouri-star-retreat-planner': esMissouriStarRetreatPlanner,
    'missouri-star-tutorial-finder': esMissouriStarTutorialFinder,
    'mulqueen-find-your-class': esMulqueenFindYourClass,
    'mulqueen-sewing-explorer': esMulqueenSewingExplorer,
    'threadworks-sewing-explorer': esThreadworksSewingExplorer,
    'svp-business-builder': esSvpBusinessBuilder,
    'svp-machine-finder': esSvpMachineFinder,
  },
  'ai-single-parent': { 'ai-single-parent-accelerators': esAiSingleParentAccelerators },
  'ai-stem': { 'ai-stem-accelerators': esAiStemAccelerators },
  'ai-university-student': { 'ai-university-student-accelerators': esAiUniversityStudentAccelerators },
  'ai-veterans': { 'ai-veterans-accelerators': esAiVeteransAccelerators },
  'ai-vocational': { 'ai-vocational-accelerators': esAiVocationalAccelerators },
  'ai-wellness-beauty': { 'ai-wellness-beauty-accelerators': esAiWellnessBeautyAccelerators },
  'ai-women': { 'ai-women-accelerators': esAiWomenAccelerators },
};

// Build the category-specific resources and namespaces based on site config
const categoryResources: Record<string, object> = {};
const esCategoryResources: Record<string, object> = {};
const categoryNamespaces: string[] = [];

for (const [slug, namespaces] of Object.entries(CATEGORY_TRANSLATIONS)) {
  if (isAcceleratorCategoryVisible(slug)) {
    for (const [ns, data] of Object.entries(namespaces)) {
      categoryResources[ns] = data;
      categoryNamespaces.push(ns);
    }
    const esNamespaces = ES_CATEGORY_TRANSLATIONS[slug];
    if (esNamespaces) {
      for (const [ns, data] of Object.entries(esNamespaces)) {
        esCategoryResources[ns] = data;
      }
    }
  }
}

// Shared namespaces (always loaded regardless of site)
const sharedNamespaces = [
  'common',
  'home',
  'home-2',
  'home-3',
  'home-4',
  'home-5',
  'admin',
  'navigation',
  'subscription-plans',
  'newsletter',
  'prv-prospecting',
  'prv-prospecting-data',
  'user-dashboard',
  'video-library',
  'org-dashboard',
  'org-subscription-success',
  'subscription-plans-org',
  'legal',
  'faq',
  // Accelerators - Common & Table (shared)
  'accelerators-common',
  'ai-accelerators-table',
  // Accelerator Narrative (shared)
  'go-to-market-strategy',
  'long-description',
  'market-size',
  'one-line-pitch',
  'problem-statement',
  'short-description',
  'solution-description',
  'target-market',
  'team-description',
  'three-year-plan',
  'traction-summary',
  'unit-economics',
  'unit-economics-dashboard',
  'use-of-funds',
  'vision-statement',
  'why-now',
  'beachhead-market',
  'business-model-canvas',
  'competitive-positioning',
  'founder-identity',
  'founder-presence',
  'funding-strategy',
  'metrics-framework',
  'milestone-roadmap',
  'product-showcase',
  'team-strategy',
  // Founders (shared)
  'investor-founder-search',
  'my-founder-lexicon',
  'my-founder-profile',
  // Calendars (shared)
  'comms-calendar',
  // Partnership Tools (shared)
  'partnership-optimizer',
  // Accelerator Tools (shared)
  'accelerator-comparison-framework',
  'acceptance-rate-reality',
  'alumni-network-estimator',
  'cohort-timing-strategy',
  'deadline-calculator',
  'demo-day-prep-guide',
  'due-diligence-checklist',
  'equity-dilution-visualizer',
  'film-studio-budget',
  'sewing-fashion-budget',
  'artist-studio-budget',
  'automotive-budget',
  'black-men-budget',
  'black-women-budget',
  'christian-budget',
  'culinary-budget',
  'disability-budget',
  'engineering-budget',
  'environment-budget',
  'furniture-making-budget',
  'hotel-hospitality-budget',
  'indigenous-budget',
  'jewish-budget',
  'lgbtq-budget',
  'latino-budget',
  'low-income-budget',
  'medical-budget',
  'minority-budget',
  'music-studio-budget',
  'muslim-budget',
  'next-step-budget',
  'panama-budget',
  'real-estate-budget',
  'rural-budget',
  'stem-budget',
  'senior-budget',
  'single-parent-budget',
  'university-student-budget',
  'veterans-budget',
  'vocational-budget',
  'wellness-beauty-budget',
  'women-budget',
  'founder-market-fit-assessment',
  'founder-story-framework',
  'funding-landscape-infographics',
  'funding-multiplier-calculator',
  'funding-readiness-assessment',
  'hidden-gems-report',
  'interview-prep-guide',
  'monthly-ama-template',
  'networking-roi-calculator',
  'pitch-deck-framework',
  'portfolio-strategy-calculator',
  'post-acceptance-negotiation',
  'program-fit-scorecard',
  'program-research-methodology',
  'reapplication-strategy-guide',
  'red-flags-checklist',
  'reference-check-guide',
  'rejection-recovery-framework',
  'sales-strategy-optimizer',
  'stage-appropriate-finder',
  'the-100-hour-problem',
  'weekly-deadline-digest',
  'what-accelerators-look-for',
  'partnership-optimizer-legacy',
  // Accelerator Tools (Value-Add Modules)
  'runway-scenario-model',
  'customer-discovery-tracker',
  'investor-pipeline-tracker',
  'investor-update-generator',
  'mentor-office-hours',
  'esop-option-pool-planner',
  'cohort-benchmarking',
  'data-room-builder',
  'my-accelerator-tracker',
  // Video Animations (per-vertical)
  'video-anim-artist-studio',
  'video-anim-automotive',
  'video-anim-black-men',
  'video-anim-black-women',
  'video-anim-christian',
  'video-anim-culinary',
  'video-anim-disability',
  'video-anim-engineering',
  'video-anim-environment',
  'video-anim-film-studio',
  'video-anim-furniture-making',
  'video-anim-hotel-hospitality',
  'video-anim-indigenous',
  'video-anim-jewish',
  'video-anim-lgbtq',
  'video-anim-latino',
  'video-anim-low-income',
  'video-anim-medical',
  'video-anim-minority',
  'video-anim-music-studio',
  'video-anim-muslim',
  'video-anim-next-step',
  'video-anim-real-estate',
  'video-anim-rural',
  'video-anim-stem',
  'video-anim-senior',
  'video-anim-sewing-fashion',
  'video-anim-single-parent',
  'video-anim-university-student',
  'video-anim-veterans',
  'video-anim-vocational',
  'video-anim-wellness-beauty',
  'video-anim-women',
  'video-anim-hifi-artist-studio',
  'video-anim-hifi-automotive',
  'video-anim-hifi-black-men',
  'video-anim-hifi-black-women',
  'video-anim-hifi-christian',
  'video-anim-hifi-culinary',
  'video-anim-hifi-disability',
  'video-anim-hifi-engineering',
  'video-anim-hifi-environment',
  'video-anim-hifi-film-studio',
  'video-anim-hifi-furniture-making',
  'video-anim-hifi-hotel-hospitality',
  'video-anim-hifi-indigenous',
  'video-anim-hifi-jewish',
  'video-anim-hifi-lgbtq',
  'video-anim-hifi-latino',
  'video-anim-hifi-low-income',
  'video-anim-hifi-medical',
  'video-anim-hifi-minority',
  'video-anim-hifi-music-studio',
  'video-anim-hifi-muslim',
  'video-anim-hifi-next-step',
  'video-anim-hifi-panama',
  'video-anim-hifi-real-estate',
  'video-anim-hifi-rural',
  'video-anim-hifi-stem',
  'video-anim-hifi-senior',
  'video-anim-hifi-sewing-fashion',
  'video-anim-hifi-single-parent',
  'video-anim-hifi-university-student',
  'video-anim-hifi-veterans',
  'video-anim-hifi-vocational',
  'video-anim-hifi-wellness-beauty',
  'video-anim-hifi-women',
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        // Shared resources (always loaded)
        common: enCommon,
        home: enHome,
        'home-2': enHome2,
        'home-3': enHome3,
        'home-4': enHome4,
        'home-5': enHome5,
        admin: enAdmin,
        navigation: enNavigation,
        'subscription-plans': enSubscriptionPlans,
        legal: enLegal,
        faq: enFaq,
        newsletter: enNewsletter,
        'prv-prospecting': enPrvProspecting,
        'prv-prospecting-data': enPrvProspectingData,
        'user-dashboard': enUserDashboard,
        'video-library': enVideoLibrary,
        'org-dashboard': enOrgDashboard,
        'org-subscription-success': enOrgSubscriptionSuccess,
        'subscription-plans-org': enSubscriptionPlansOrg,
        // Accelerators - Common (shared)
        'accelerators-common': enAcceleratorsCommon,
        'ai-accelerators-table': enAiAcceleratorsTable,
        // Accelerator Narrative (shared)
        'go-to-market-strategy': enGoToMarketStrategy,
        'long-description': enLongDescription,
        'market-size': enMarketSize,
        'one-line-pitch': enOneLinePitch,
        'problem-statement': enProblemStatement,
        'short-description': enShortDescription,
        'solution-description': enSolutionDescription,
        'target-market': enTargetMarket,
        'team-description': enTeamDescription,
        'three-year-plan': enThreeYearPlan,
        'traction-summary': enTractionSummary,
        'unit-economics': enUnitEconomics,
        'unit-economics-dashboard': enUnitEconomicsDashboard,
        'use-of-funds': enUseOfFunds,
        'vision-statement': enVisionStatement,
        'why-now': enWhyNow,
        'beachhead-market': enBeachheadMarket,
        'business-model-canvas': enBusinessModelCanvas,
        'competitive-positioning': enCompetitivePositioning,
        'founder-identity': enFounderIdentity,
        'founder-presence': enFounderPresence,
        'funding-strategy': enFundingStrategy,
        'metrics-framework': enMetricsFramework,
        'milestone-roadmap': enMilestoneRoadmap,
        'product-showcase': enProductShowcase,
        'team-strategy': enTeamStrategy,
        // Founders (shared)
        'investor-founder-search': enInvestorFounderSearch,
        'my-founder-lexicon': enMyFounderLexicon,
        'my-founder-profile': enMyFounderProfile,
        // Calendars (shared)
        'comms-calendar': enCommsCalendar,
        // Partnership Tools (shared)
        'partnership-optimizer': enPartnershipOptimizer,
        // Accelerator Tools (shared)
        'accelerator-comparison-framework': enAcceleratorComparisonFramework,
        'acceptance-rate-reality': enAcceptanceRateReality,
        'alumni-network-estimator': enAlumniNetworkEstimator,
        'cohort-timing-strategy': enCohortTimingStrategy,
        'deadline-calculator': enDeadlineCalculator,
        'demo-day-prep-guide': enDemoDayPrepGuide,
        'due-diligence-checklist': enDueDiligenceChecklist,
        'equity-dilution-visualizer': enEquityDilutionVisualizer,
        'safe-investment-model': enSafeInvestmentModel,
        'film-studio-budget': enFilmStudioBudget,
        'sewing-fashion-budget': enSewingFashionBudget,
        'artist-studio-budget': enArtistStudioBudget,
        'automotive-budget': enAutomotiveBudget,
        'black-men-budget': enBlackMenBudget,
        'black-women-budget': enBlackWomenBudget,
        'christian-budget': enChristianBudget,
        'culinary-budget': enCulinaryBudget,
        'disability-budget': enDisabilityBudget,
        'engineering-budget': enEngineeringBudget,
        'environment-budget': enEnvironmentBudget,
        'furniture-making-budget': enFurnitureMakingBudget,
        'hotel-hospitality-budget': enHotelHospitalityBudget,
        'indigenous-budget': enIndigenousBudget,
        'jewish-budget': enJewishBudget,
        'lgbtq-budget': enLGBTQBudget,
        'latino-budget': enLatinoBudget,
        'low-income-budget': enLowIncomeBudget,
        'medical-budget': enMedicalBudget,
        'minority-budget': enMinorityBudget,
        'music-studio-budget': enMusicStudioBudget,
        'muslim-budget': enMuslimBudget,
        'next-step-budget': enNextStepBudget,
        'panama-budget': enPanamaBudget,
        'real-estate-budget': enRealEstateBudget,
        'rural-budget': enRuralBudget,
        'stem-budget': enSTEMBudget,
        'senior-budget': enSeniorBudget,
        'single-parent-budget': enSingleParentBudget,
        'university-student-budget': enUniversityStudentBudget,
        'veterans-budget': enVeteransBudget,
        'vocational-budget': enVocationalBudget,
        'wellness-beauty-budget': enWellnessBeautyBudget,
        'women-budget': enWomenBudget,
        'founder-market-fit-assessment': enFounderMarketFitAssessment,
        'founder-story-framework': enFounderStoryFramework,
        'funding-landscape-infographics': enFundingLandscapeInfographics,
        'funding-multiplier-calculator': enFundingMultiplierCalculator,
        'funding-readiness-assessment': enFundingReadinessAssessment,
        'hidden-gems-report': enHiddenGemsReport,
        'interview-prep-guide': enInterviewPrepGuide,
        'monthly-ama-template': enMonthlyAmaTemplate,
        'networking-roi-calculator': enNetworkingRoiCalculator,
        'pitch-deck-framework': enPitchDeckFramework,
        'portfolio-strategy-calculator': enPortfolioStrategyCalculator,
        'post-acceptance-negotiation': enPostAcceptanceNegotiation,
        'program-fit-scorecard': enProgramFitScorecard,
        'program-research-methodology': enProgramResearchMethodology,
        'reapplication-strategy-guide': enReapplicationStrategyGuide,
        'red-flags-checklist': enRedFlagsChecklist,
        'reference-check-guide': enReferenceCheckGuide,
        'rejection-recovery-framework': enRejectionRecoveryFramework,
        'sales-strategy-optimizer': enSalesStrategyOptimizer,
        'stage-appropriate-finder': enStageAppropriateFinder,
        'the-100-hour-problem': enThe100HourProblem,
        'weekly-deadline-digest': enWeeklyDeadlineDigest,
        'what-accelerators-look-for': enWhatAcceleratorsLookFor,
        'partnership-optimizer-legacy': enPartnershipOptimizerLegacy,
        // Accelerator Tools (Value-Add Modules)
        'runway-scenario-model': enRunwayScenarioModel,
        'customer-discovery-tracker': enCustomerDiscoveryTracker,
        'investor-pipeline-tracker': enInvestorPipelineTracker,
        'investor-update-generator': enInvestorUpdateGenerator,
        'mentor-office-hours': enMentorOfficeHours,
        'esop-option-pool-planner': enEsopOptionPoolPlanner,
        'cohort-benchmarking': enCohortBenchmarking,
        'data-room-builder': enDataRoomBuilder,
        'my-accelerator-tracker': enMyAcceleratorTracker,
        // Video Animations (per-vertical)
        'video-anim-artist-studio': enVideoAnimArtistStudio,
        'video-anim-automotive': enVideoAnimAutomotive,
        'video-anim-black-men': enVideoAnimBlackMen,
        'video-anim-black-women': enVideoAnimBlackWomen,
        'video-anim-christian': enVideoAnimChristian,
        'video-anim-culinary': enVideoAnimCulinary,
        'video-anim-disability': enVideoAnimDisability,
        'video-anim-engineering': enVideoAnimEngineering,
        'video-anim-environment': enVideoAnimEnvironment,
        'video-anim-film-studio': enVideoAnimFilmStudio,
        'video-anim-furniture-making': enVideoAnimFurnitureMaking,
        'video-anim-hotel-hospitality': enVideoAnimHotelHospitality,
        'video-anim-indigenous': enVideoAnimIndigenous,
        'video-anim-jewish': enVideoAnimJewish,
        'video-anim-lgbtq': enVideoAnimLGBTQ,
        'video-anim-latino': enVideoAnimLatino,
        'video-anim-low-income': enVideoAnimLowIncome,
        'video-anim-medical': enVideoAnimMedical,
        'video-anim-minority': enVideoAnimMinority,
        'video-anim-music-studio': enVideoAnimMusicStudio,
        'video-anim-muslim': enVideoAnimMuslim,
        'video-anim-next-step': enVideoAnimNextStep,
        'video-anim-real-estate': enVideoAnimRealEstate,
        'video-anim-rural': enVideoAnimRural,
        'video-anim-stem': enVideoAnimSTEM,
        'video-anim-senior': enVideoAnimSenior,
        'video-anim-sewing-fashion': enVideoAnimSewingFashion,
        'video-anim-single-parent': enVideoAnimSingleParent,
        'video-anim-university-student': enVideoAnimUniversityStudent,
        'video-anim-veterans': enVideoAnimVeterans,
        'video-anim-vocational': enVideoAnimVocational,
        'video-anim-wellness-beauty': enVideoAnimWellnessBeauty,
        'video-anim-women': enVideoAnimWomen,
        'video-anim-hifi-artist-studio': enVideoAnimHifiArtistStudio,
        'video-anim-hifi-automotive': enVideoAnimHifiAutomotive,
        'video-anim-hifi-black-men': enVideoAnimHifiBlackMen,
        'video-anim-hifi-black-women': enVideoAnimHifiBlackWomen,
        'video-anim-hifi-christian': enVideoAnimHifiChristian,
        'video-anim-hifi-culinary': enVideoAnimHifiCulinary,
        'video-anim-hifi-disability': enVideoAnimHifiDisability,
        'video-anim-hifi-engineering': enVideoAnimHifiEngineering,
        'video-anim-hifi-environment': enVideoAnimHifiEnvironment,
        'video-anim-hifi-film-studio': enVideoAnimHifiFilmStudio,
        'video-anim-hifi-furniture-making': enVideoAnimHifiFurnitureMaking,
        'video-anim-hifi-hotel-hospitality': enVideoAnimHifiHotelHospitality,
        'video-anim-hifi-indigenous': enVideoAnimHifiIndigenous,
        'video-anim-hifi-jewish': enVideoAnimHifiJewish,
        'video-anim-hifi-lgbtq': enVideoAnimHifiLGBTQ,
        'video-anim-hifi-latino': enVideoAnimHifiLatino,
        'video-anim-hifi-low-income': enVideoAnimHifiLowIncome,
        'video-anim-hifi-medical': enVideoAnimHifiMedical,
        'video-anim-hifi-minority': enVideoAnimHifiMinority,
        'video-anim-hifi-music-studio': enVideoAnimHifiMusicStudio,
        'video-anim-hifi-muslim': enVideoAnimHifiMuslim,
        'video-anim-hifi-next-step': enVideoAnimHifiNextStep,
        'video-anim-hifi-panama': enVideoAnimHifiPanama,
        'video-anim-hifi-real-estate': enVideoAnimHifiRealEstate,
        'video-anim-hifi-rural': enVideoAnimHifiRural,
        'video-anim-hifi-stem': enVideoAnimHifiSTEM,
        'video-anim-hifi-senior': enVideoAnimHifiSenior,
        'video-anim-hifi-sewing-fashion': enVideoAnimHifiSewingFashion,
        'video-anim-hifi-single-parent': enVideoAnimHifiSingleParent,
        'video-anim-hifi-university-student': enVideoAnimHifiUniversityStudent,
        'video-anim-hifi-veterans': enVideoAnimHifiVeterans,
        'video-anim-hifi-vocational': enVideoAnimHifiVocational,
        'video-anim-hifi-wellness-beauty': enVideoAnimHifiWellnessBeauty,
        'video-anim-hifi-women': enVideoAnimHifiWomen,
        // Category-specific resources (filtered by site config)
        ...categoryResources,
      },
      es: {
        common: esCommon,
        home: esHome,
        'home-2': esHome2,
        'home-3': esHome3,
        'home-4': esHome4,
        'home-5': esHome5,
        admin: esAdmin,
        navigation: esNavigation,
        'subscription-plans': esSubscriptionPlans,
        legal: esLegal,
        faq: esFaq,
        newsletter: esNewsletter,
        'prv-prospecting': esPrvProspecting,
        'prv-prospecting-data': esPrvProspectingData,
        'user-dashboard': esUserDashboard,
        'video-library': esVideoLibrary,
        // Accelerators - Common (shared)
        'accelerators-common': esAcceleratorsCommon,
        'ai-accelerators-table': esAiAcceleratorsTable,
        // Accelerator Narrative (shared)
        'go-to-market-strategy': esGoToMarketStrategy,
        'long-description': esLongDescription,
        'market-size': esMarketSize,
        'one-line-pitch': esOneLinePitch,
        'problem-statement': esProblemStatement,
        'short-description': esShortDescription,
        'solution-description': esSolutionDescription,
        'target-market': esTargetMarket,
        'team-description': esTeamDescription,
        'three-year-plan': esThreeYearPlan,
        'traction-summary': esTractionSummary,
        'unit-economics': esUnitEconomics,
        'unit-economics-dashboard': esUnitEconomicsDashboard,
        'use-of-funds': esUseOfFunds,
        'vision-statement': esVisionStatement,
        'why-now': esWhyNow,
        'beachhead-market': esBeachheadMarket,
        'business-model-canvas': esBusinessModelCanvas,
        'competitive-positioning': esCompetitivePositioning,
        'founder-identity': esFounderIdentity,
        'founder-presence': esFounderPresence,
        'funding-strategy': esFundingStrategy,
        'metrics-framework': esMetricsFramework,
        'milestone-roadmap': esMilestoneRoadmap,
        'product-showcase': esProductShowcase,
        'team-strategy': esTeamStrategy,
        // Founders (shared)
        'investor-founder-search': esInvestorFounderSearch,
        'my-founder-lexicon': esMyFounderLexicon,
        'my-founder-profile': esMyFounderProfile,
        // Calendars (shared)
        'comms-calendar': esCommsCalendar,
        // Partnership Tools (shared)
        'partnership-optimizer': esPartnershipOptimizer,
        // Accelerator Tools (shared)
        'accelerator-comparison-framework': esAcceleratorComparisonFramework,
        'acceptance-rate-reality': esAcceptanceRateReality,
        'alumni-network-estimator': esAlumniNetworkEstimator,
        'cohort-timing-strategy': esCohortTimingStrategy,
        'deadline-calculator': esDeadlineCalculator,
        'demo-day-prep-guide': esDemoDayPrepGuide,
        'due-diligence-checklist': esDueDiligenceChecklist,
        'equity-dilution-visualizer': esEquityDilutionVisualizer,
        'safe-investment-model': esSafeInvestmentModel,
        'film-studio-budget': esFilmStudioBudget,
        'sewing-fashion-budget': esSewingFashionBudget,
        'artist-studio-budget': esArtistStudioBudget,
        'automotive-budget': esAutomotiveBudget,
        'black-men-budget': esBlackMenBudget,
        'black-women-budget': esBlackWomenBudget,
        'christian-budget': esChristianBudget,
        'culinary-budget': esCulinaryBudget,
        'disability-budget': esDisabilityBudget,
        'engineering-budget': esEngineeringBudget,
        'environment-budget': esEnvironmentBudget,
        'furniture-making-budget': esFurnitureMakingBudget,
        'hotel-hospitality-budget': esHotelHospitalityBudget,
        'indigenous-budget': esIndigenousBudget,
        'jewish-budget': esJewishBudget,
        'lgbtq-budget': esLGBTQBudget,
        'latino-budget': esLatinoBudget,
        'low-income-budget': esLowIncomeBudget,
        'medical-budget': esMedicalBudget,
        'minority-budget': esMinorityBudget,
        'music-studio-budget': esMusicStudioBudget,
        'muslim-budget': esMuslimBudget,
        'next-step-budget': esNextStepBudget,
        'panama-budget': esPanamaBudget,
        'real-estate-budget': esRealEstateBudget,
        'rural-budget': esRuralBudget,
        'stem-budget': esSTEMBudget,
        'senior-budget': esSeniorBudget,
        'single-parent-budget': esSingleParentBudget,
        'university-student-budget': esUniversityStudentBudget,
        'veterans-budget': esVeteransBudget,
        'vocational-budget': esVocationalBudget,
        'wellness-beauty-budget': esWellnessBeautyBudget,
        'women-budget': esWomenBudget,
        'founder-market-fit-assessment': esFounderMarketFitAssessment,
        'founder-story-framework': esFounderStoryFramework,
        'funding-landscape-infographics': esFundingLandscapeInfographics,
        'funding-multiplier-calculator': esFundingMultiplierCalculator,
        'funding-readiness-assessment': esFundingReadinessAssessment,
        'hidden-gems-report': esHiddenGemsReport,
        'interview-prep-guide': esInterviewPrepGuide,
        'monthly-ama-template': esMonthlyAmaTemplate,
        'networking-roi-calculator': esNetworkingRoiCalculator,
        'pitch-deck-framework': esPitchDeckFramework,
        'portfolio-strategy-calculator': esPortfolioStrategyCalculator,
        'post-acceptance-negotiation': esPostAcceptanceNegotiation,
        'program-fit-scorecard': esProgramFitScorecard,
        'program-research-methodology': esProgramResearchMethodology,
        'reapplication-strategy-guide': esReapplicationStrategyGuide,
        'red-flags-checklist': esRedFlagsChecklist,
        'reference-check-guide': esReferenceCheckGuide,
        'rejection-recovery-framework': esRejectionRecoveryFramework,
        'sales-strategy-optimizer': esSalesStrategyOptimizer,
        'stage-appropriate-finder': esStageAppropriateFinder,
        'the-100-hour-problem': esThe100HourProblem,
        'weekly-deadline-digest': esWeeklyDeadlineDigest,
        'what-accelerators-look-for': esWhatAcceleratorsLookFor,
        'partnership-optimizer-legacy': esPartnershipOptimizerLegacy,
        // Accelerator Tools (Value-Add Modules)
        'runway-scenario-model': esRunwayScenarioModel,
        'customer-discovery-tracker': esCustomerDiscoveryTracker,
        'investor-pipeline-tracker': esInvestorPipelineTracker,
        'investor-update-generator': esInvestorUpdateGenerator,
        'mentor-office-hours': esMentorOfficeHours,
        'esop-option-pool-planner': esEsopOptionPoolPlanner,
        'cohort-benchmarking': esCohortBenchmarking,
        'data-room-builder': esDataRoomBuilder,
        'my-accelerator-tracker': esMyAcceleratorTracker,
        // Video Animations (per-vertical)
        'video-anim-artist-studio': esVideoAnimArtistStudio,
        'video-anim-automotive': esVideoAnimAutomotive,
        'video-anim-black-men': esVideoAnimBlackMen,
        'video-anim-black-women': esVideoAnimBlackWomen,
        'video-anim-christian': esVideoAnimChristian,
        'video-anim-culinary': esVideoAnimCulinary,
        'video-anim-disability': esVideoAnimDisability,
        'video-anim-engineering': esVideoAnimEngineering,
        'video-anim-environment': esVideoAnimEnvironment,
        'video-anim-film-studio': esVideoAnimFilmStudio,
        'video-anim-furniture-making': esVideoAnimFurnitureMaking,
        'video-anim-hotel-hospitality': esVideoAnimHotelHospitality,
        'video-anim-indigenous': esVideoAnimIndigenous,
        'video-anim-jewish': esVideoAnimJewish,
        'video-anim-lgbtq': esVideoAnimLGBTQ,
        'video-anim-latino': esVideoAnimLatino,
        'video-anim-low-income': esVideoAnimLowIncome,
        'video-anim-medical': esVideoAnimMedical,
        'video-anim-minority': esVideoAnimMinority,
        'video-anim-music-studio': esVideoAnimMusicStudio,
        'video-anim-muslim': esVideoAnimMuslim,
        'video-anim-next-step': esVideoAnimNextStep,
        'video-anim-real-estate': esVideoAnimRealEstate,
        'video-anim-rural': esVideoAnimRural,
        'video-anim-stem': esVideoAnimSTEM,
        'video-anim-senior': esVideoAnimSenior,
        'video-anim-sewing-fashion': esVideoAnimSewingFashion,
        'video-anim-single-parent': esVideoAnimSingleParent,
        'video-anim-university-student': esVideoAnimUniversityStudent,
        'video-anim-veterans': esVideoAnimVeterans,
        'video-anim-vocational': esVideoAnimVocational,
        'video-anim-wellness-beauty': esVideoAnimWellnessBeauty,
        'video-anim-women': esVideoAnimWomen,
        'video-anim-hifi-artist-studio': esVideoAnimHifiArtistStudio,
        'video-anim-hifi-automotive': esVideoAnimHifiAutomotive,
        'video-anim-hifi-black-men': esVideoAnimHifiBlackMen,
        'video-anim-hifi-black-women': esVideoAnimHifiBlackWomen,
        'video-anim-hifi-christian': esVideoAnimHifiChristian,
        'video-anim-hifi-culinary': esVideoAnimHifiCulinary,
        'video-anim-hifi-disability': esVideoAnimHifiDisability,
        'video-anim-hifi-engineering': esVideoAnimHifiEngineering,
        'video-anim-hifi-environment': esVideoAnimHifiEnvironment,
        'video-anim-hifi-film-studio': esVideoAnimHifiFilmStudio,
        'video-anim-hifi-furniture-making': esVideoAnimHifiFurnitureMaking,
        'video-anim-hifi-hotel-hospitality': esVideoAnimHifiHotelHospitality,
        'video-anim-hifi-indigenous': esVideoAnimHifiIndigenous,
        'video-anim-hifi-jewish': esVideoAnimHifiJewish,
        'video-anim-hifi-lgbtq': esVideoAnimHifiLGBTQ,
        'video-anim-hifi-latino': esVideoAnimHifiLatino,
        'video-anim-hifi-low-income': esVideoAnimHifiLowIncome,
        'video-anim-hifi-medical': esVideoAnimHifiMedical,
        'video-anim-hifi-minority': esVideoAnimHifiMinority,
        'video-anim-hifi-music-studio': esVideoAnimHifiMusicStudio,
        'video-anim-hifi-muslim': esVideoAnimHifiMuslim,
        'video-anim-hifi-next-step': esVideoAnimHifiNextStep,
        'video-anim-hifi-panama': esVideoAnimHifiPanama,
        'video-anim-hifi-real-estate': esVideoAnimHifiRealEstate,
        'video-anim-hifi-rural': esVideoAnimHifiRural,
        'video-anim-hifi-stem': esVideoAnimHifiSTEM,
        'video-anim-hifi-senior': esVideoAnimHifiSenior,
        'video-anim-hifi-sewing-fashion': esVideoAnimHifiSewingFashion,
        'video-anim-hifi-single-parent': esVideoAnimHifiSingleParent,
        'video-anim-hifi-university-student': esVideoAnimHifiUniversityStudent,
        'video-anim-hifi-veterans': esVideoAnimHifiVeterans,
        'video-anim-hifi-vocational': esVideoAnimHifiVocational,
        'video-anim-hifi-wellness-beauty': esVideoAnimHifiWellnessBeauty,
        'video-anim-hifi-women': esVideoAnimHifiWomen,
        // Category-specific resources (filtered by site config)
        ...esCategoryResources,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    defaultNS: 'common',
    ns: [...sharedNamespaces, ...categoryNamespaces],
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
